/* eslint-disable-next-line primer-react/no-deprecated-flash -- Preserve the existing queue error presentation. */
import {Flash} from '@primer/react'
import {StopIcon} from '@primer/octicons-react'
import {FlashError} from '@github-ui/flash-error'

export type MergeQueueErrorDetails = {
  message?: string
  ruleErrors?: string[]
}

export function MergeQueueError({error}: {error: MergeQueueErrorDetails}) {
  if (error.ruleErrors && error.ruleErrors.length > 0) {
    return (
      <FlashError
        prefix=""
        helpUrl=""
        errorMessageNotUsingPrefix="Repository rule violations found"
        hideRuleErrorsTitle
        ruleErrors={error.ruleErrors}
      />
    )
  }

  return error.message ? (
    <Flash className="tmp-mb-3" variant="danger">
      <StopIcon className="mr-2" />
      {error.message}
    </Flash>
  ) : null
}
